import {ModuleWithProviders, NgModule} from '@angular/core';
import {DeviceNotificationService} from './device-notification.service';
import {IonicModule} from '@ionic/angular';
import {DatabaseModule} from '@core/database';
import {SettingsModule} from '@plugin/settings';

@NgModule({
    imports: [
        IonicModule,
        DatabaseModule,
        SettingsModule
    ],
    declarations: [],
    exports: []
})
export class DeviceNotificationModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: DeviceNotificationModule,
            providers: [
                { provide: DeviceNotificationService, useClass: DeviceNotificationService },
            ]
        }
    }
}
